module.exports = {
	"en": "en",
	"fr": "fr",
	"it": "it",
	"de": "de",
	"aa": "aa",
	"ab": "ab",
	"af": "af",
	"am": "am",
	"ar": "ar",
	"as": "as",
	"ay": "ay",
	"az": "az",
	"ba": "ba",
	"be": "be",
	"bg": "bg",
	"bh": "bh",
	"bi": "bi",
	"bn": "bn",
	"bo": "bo",
	"br": "br",
	"ca": "ca",
	"co": "co",
	"cs": "cs",
	"cy": "cy",
	"da": "da",
	"dz": "dz",
	"el": "el",
	"eo": "eo",
	"es": "es",
	"et": "et",
	"eu": "eu",
	"fa": "fa",
	"fi": "fi",
	"fj": "fj",
	"fo": "fo",
	"fy": "fy",
	"ga": "ga",
	"gd": "gd",
	"gl": "gl",
	"gn": "gn",
	"gu": "gu",
	"ha": "ha",
	"hi": "hi",
	"he": "he",
	"hr": "hr",
	"hu": "hu",
	"hy": "hy",
	"ia": "ia",
	"id": "id",
	"ie": "ie",
	"ik": "ik",
	"in": "in",
	"is": "is",
	"iu": "iu",
	"iw": "iw",
	"ja": "ja",
	"ji": "ji",
	"jw": "jw",
	"ka": "ka",
	"kk": "kk",
	"kl": "kl",
	"km": "km",
	"kn": "kn",
	"ko": "ko",
	"ks": "ks",
	"ku": "ku",
	"ky": "ky",
	"la": "la",
	"ln": "ln",
	"lo": "lo",
	"lt": "lt",
	"lv": "lv",
	"mg": "mg",
	"mi": "mi",
	"mk": "mk",
	"ml": "ml",
	"mn": "mn",
	"mo": "mo",
	"mr": "mr",
	"ms": "ms",
	"mt": "mt",
	"my": "my",
	"na": "na",
	"ne": "ne",
	"nl": "nl",
	"no": "no",
	"oc": "oc",
	"om": "om",
	"or": "or",
	"pa": "pa",
	"pl": "pl",
	"ps": "ps",
	"pt": "pt",
	"qu": "qu",
	"rm": "rm",
	"rn": "rn",
	"ro": "ro",
	"ru": "ru",
	"rw": "rw",
	"sa": "sa",
	"sd": "sd",
	"sg": "sg",
	"sh": "sh",
	"si": "si",
	"sk": "sk",
	"sl": "sl",
	"sm": "sm",
	"sn": "sn",
	"so": "so",
	"sq": "sq",
	"sr": "sr",
	"ss": "ss",
	"st": "st",
	"su": "su",
	"sv": "sv",
	"sw": "sw",
	"ta": "ta",
	"te": "te",
	"tg": "tg",
	"th": "th",
	"ti": "ti",
	"tk": "tk",
	"tl": "tl",
	"tn": "tn",
	"to": "to",
	"tr": "tr",
	"ts": "ts",
	"tt": "tt",
	"tw": "tw",
	"ug": "ug",
	"uk": "uk",
	"ur": "ur",
	"uz": "uz",
	"vi": "vi",
	"vo": "vo",
	"wo": "wo",
	"xh": "xh",
	"yi": "yi",
	"yo": "yo",
	"za": "za",
	"zh": "zh",
	"zu": "zu"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/geocoder-geojson/utils/ISO_639-2_alpha-2.json
 ** module id = 760
 ** module chunks = 0
 **/